<!-- <ce-local-map [station]="station" [connectors]="connectors"></ce-local-map> -->

<div fxLayout="column-reverse" fxLayout.gt-sm="row" fxLayoutGap="16px" fxLayoutAlign="start start">
    <div class="map-side" fxFlex fxLayout="column" [class.maximized]="mapMaximized">
        <!-- Map -->
        <div class="map">
            <div class="map-inner">
                <!-- "Station Grid" -->
                <ce-satellites
                    *ngIf="hideWorldMap || !showWorldMap"
                    [wrap]="true"
                    [showSatellites]="includesKempowerHw"
                    [satellites]="satellites"
                    [displayStationName]="true"
                    [displayTxInline]="false"
                    [mapMaximized]="mapMaximized"
                ></ce-satellites>

                <!-- "World map" -->
                <ce-map
                    *ngIf="!hideWorldMap && showWorldMap && location"
                    (locationChanged)="locationChangedHandler($event)"
                    [maximized]="mapMaximized"
                    [stations]="stationsInfo"
                    [location]="location"
                    [loadingMapData$]="loadingMapData$"
                    [mapUpdateEvent$]="mapDataChanged$"
                ></ce-map>
            </div>
            <div class="map-toggle-control" *ngIf="!hideWorldMap">
                <button
                    mat-button
                    (click)="changeMapStatus(true)"
                    (keydown.enter)="changeMapStatus(true)"
                    matTooltip="Show world map"
                    *ngIf="!showWorldMap"
                >
                    <mat-icon svgIcon="map"></mat-icon> Map
                </button>
                <button
                    mat-button
                    (click)="changeMapStatus(false)"
                    (keydown.enter)="changeMapStatus(false)"
                    matTooltip="Show station grid"
                    *ngIf="showWorldMap"
                >
                    <mat-icon svgIcon="dots-grid"></mat-icon> Grid
                </button>
                <button
                    [matTooltip]="mapMaximized ? 'Minimize' : 'Maximize'"
                    (click)="toggleMap()"
                    (keydown.enter)="toggleMap()"
                    mat-icon-button
                >
                    <mat-icon svgIcon="c-maximize"></mat-icon>
                </button>
            </div>
        </div>
        <!-- total power graph / timeline -->
        <!-- show timeline only if no depot master (as scheduling view below tells you the same thing- almost) -->
        <div class="timeline" *ngIf="locationId">
            <ce-timeline-controls
                [(seekTime)]="seekTime"
                [(startTime)]="startTime"
                [(endTime)]="endTime"
                [(zoomLevel)]="zoomLevel"
                [locationUid]="locationId"
                [hideDownloadExcel]="!locationId || hideExcelExport"
                (downloadExcelChange)="downloadLocationPowerUsageExcel($event)"
            ></ce-timeline-controls>

            <ce-timeline
                [locationUid]="locationId"
                [connectors]="[]"
                [(zoomLevel)]="zoomLevel"
                [(startTime)]="startTime"
                [(endTime)]="endTime"
            >
            </ce-timeline>
        </div>
    </div>
    <!-- Tiles -->
    <div class="tiles" *ngIf="!mapMaximized" fxFlex fxLayout="row wrap" fxLayoutGap="16px grid">
        <!-- Alerts requires same perms as ticketing - included in service tools right -->
        <ce-tile-alerts
            *requireAccessAny="'fleet.chargingStation.ticketing.access'"
            [locationId]="locationId"
        ></ce-tile-alerts>
        <ng-container *ngIf="stationIds?.length">
            <ce-tile-ticket
                [locationId]="locationId"
                *requireAccessAny="'fleet.chargingStation.ticketing.access'"
            ></ce-tile-ticket>
            <ce-tile-sessions
                [locationId]="locationId"
                *requireAccessAny="'chargingSessions.access'"
            ></ce-tile-sessions>
            <ce-tile-usage
                [stationIds]="stationIds"
                *requireAccessAny="'fleet.chargingStation.usage.access'"
            ></ce-tile-usage>
        </ng-container>
    </div>
</div>
<button *ngIf="allowScheduleView" mat-raised-button (click)="goToSchedule()" (keydown.enter)="goToSchedule()">
    <mat-icon svgIcon="m-calendar-edit"></mat-icon>
    Timeline (schedule editor)
</button>
